import styles from "./PurchaseExchange.module.scss";
import SliderCaptcha from "../../components/FormModalWindow/SliderCaptcha/SliderCaptcha";
import MyButton from "../../components/UI/MyButton/MyButton";
import presaleStore from "../../stores/presaleStore";
import { PUBLIC_ICON, PUBLIC_IMAGE } from "../../constants";
import { useNavigate } from "react-router";
import {
  ACCOUNT_ROUTE,
  PRESALE_EXCHANGE_DONE_ROUTE,
  PRESALE_EXCHANGE_ROUTE,
  PRESALE_ROUTE,
} from "../../utils/consts";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../..";
import { check } from "../../http/userAPI";
import { observer } from "mobx-react-lite";
import MySpinner from "../../components/UI/MySpinner/MySpinner";
import MyInput from "../../components/UI/MyInput/MyInput";
import { Helmet } from "react-helmet";

const PurchaseExcahnge = () => {
  const { user } = useContext(Context);
  const qrImage = PUBLIC_IMAGE + "modal-qr.png";
  const [captchaDone, setCaptchaDone] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    presaleStore.getDataExchnagePresale();
  }, []);

  useEffect(() => {
    const endTime =
      new Date(presaleStore.buyInfo?.timestamp).getTime() + 15 * 60 * 1000;
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        setTimeLeft(0);
        setDisabled(true);
        clearInterval(interval);
      } else {
        setTimeLeft(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [presaleStore.buyInfo?.timestamp]);

  const formatTime = (ms: number) => {
    if (!ms || ms <= 0) {
      return <MySpinner />;
    }

    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleCaptchaFailure = () => {
    setCaptchaDone(false);
  };

  const handleCaptchaSuccess = () => {
    setCaptchaDone(true);
  };

  const handleButtonClose = () => {
    presaleStore.setDataValid(undefined);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const sendPayConfirm = async () => {
    try {
      const res = await fetch(
        "/api/v1/presale/pay/confirm",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: presaleStore.buyInfo.id,
            user_id: user._userInfo?.profile.user_id,
            id_payd: "yes",
            out_address: walletAddress,
          }),
        }
      );
      if (!res.ok) {
        throw new Error(`Ошибка сервера: ${res.status}`);
      }

      const result = await res.json();
    } catch {
      console.error("Ошибка при выполнении fetch-запроса checkPayd:");
    }
  };

  const handleButtonPaid = async () => {
    if (!captchaDone) {
      alert("The Captcha has not been solved");
    } else if (!walletAddress || walletAddress.trim() === "") {
      alert("Please enter your wallet address.");
    } else {
      navigate(PRESALE_EXCHANGE_DONE_ROUTE);
      await sendPayConfirm();
      presaleStore.setIsPaid(1);
    }
  };

  const getFormattedDate = (dateString: string): string => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const formatter = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: "UTC",
    });

    return formatter.format(date);
  };

  const truncateCode = (email: string) => {
    if (!email || email.length <= 6) return email;
    return `${email.slice(0, 8)}...${email.slice(-8)}`;
  };

  const handlerWalletAddressChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputValue = e.target.value;
    setWalletAddress(inputValue);
  };

  return (
    <>
      <Helmet>
        <title>Profile</title>
        <link rel="icon" href={PUBLIC_ICON + "Alfa.svg"} />
      </Helmet>
      <div className={styles.modal__windowWrapper}>
        <div className={styles.modal__window}>
          <div className={styles.modal__windowTimer}>
            {formatTime(timeLeft)}
          </div>
          <div className={styles.modal__windowWrapper}>
            <div className={styles.modal__howToPlay}></div>
            <div className={styles.modal__canceled}></div>
            <div className={styles.modal__QrWrapper}>
              <div className={styles.qr__imageWrapper}>
                <img
                  src={`data:image/png;base64,${presaleStore.buyInfo?.qr_code}`}
                  className={styles.qr__image}
                  alt="QR code"
                />
              </div>
              <div className={styles.qr__text}>
                Please note that the rate is fixed after 12 network
                confirmations. Attention! Your transaction will be checked
                according to the AML Policy of the exchange office.
              </div>
            </div>
            <div className={styles.inputWalletAdressWrapper}>
              <span>Adress wallet</span>
              <MyInput
                className={styles.inputWalletAdress}
                placeHolder="Enter your wallet adress"
                onChange={handlerWalletAddressChange}
              ></MyInput>
            </div>
            <div className={styles.modal__sliderWrapper}>
              <SliderCaptcha
                onSuccess={handleCaptchaSuccess}
                onFailure={handleCaptchaFailure}
                walletAddress={presaleStore.buyInfo?.address_dest || ""}
              />
              <div
                className={styles.slider__walletAddress}
                data-full={presaleStore.buyInfo?.address_dest}
              >
                {truncateCode(presaleStore.buyInfo?.address_dest)}
              </div>
            </div>
            <div className={styles.modal__afterPayment}>
              After payment. Click on the "I paid the application" button.{" "}
              <br></br>
              Wait for the operator to process the application
            </div>
            <div className={styles.modal__amount}>
              <div className={styles.amount__text}>
                <div className={styles.amount__textWeaving}>Sent</div>
                <div className={styles.amount__textReceived}>Received</div>
                <div className={styles.amount__textReceipt}>Transaction ID</div>
              </div>
              <div className={styles.amount__value}>
                <div className={styles.amount__valueWeaving}>
                  {user.isLoading ? (
                    <MySpinner />
                  ) : (
                    `${presaleStore.buyInfo?.crypto_count} ${
                      ["TRC20", "ERC20"].includes(
                        presaleStore.buyInfo?.name ?? ""
                      )
                        ? `USDT ${presaleStore.buyInfo?.name}`
                        : presaleStore.buyInfo?.name
                    }`
                  )}
                </div>
                <div className={styles.amount__valueReceived}>
                  {user.isLoading ? (
                    <MySpinner />
                  ) : (
                    presaleStore.buyInfo?.alfa_count
                  )}{" "}
                  Alfa
                </div>
                <div className={styles.amount__valueReceipt}>
                  {user.isLoading ? <MySpinner /> : presaleStore.buyInfo?.id}
                </div>
              </div>
            </div>
            <div className={styles.modal__notification}>
              You need to pay an additional
              {user.isLoading ? (
                <MySpinner />
              ) : (
                ` ${presaleStore.buyInfo?.debt} ${
                  ["TRC20", "ERC20"].includes(presaleStore.buyInfo?.name ?? "")
                    ? `USDT ${presaleStore.buyInfo?.name}`
                    : presaleStore.buyInfo?.name
                }`
              )}
            </div>
            <div className={styles.modal__beCareful}>
              Please be careful! All fields must be filled in exact accordance
              with the instructions. Otherwise, the payment may not go through.
            </div>
          </div>
          <div className={styles.modal__buttonGroup}>
            {/* <MyButton
          className={styles.modal__buttonCancel}
          onClick={handleButtonCancel}
            <div className={styles.timestatus__timeText}>Creation time</div>
            <div className={styles.timestatus__dateTime}>{buyInfo.timestamp}</div>
        </MyButton> */}
            <MyButton
              className={styles.modal__buttonPaid}
              onClick={handleButtonPaid}
              disabled={disabled}
            >
              {" "}
              I paid{" "}
            </MyButton>
          </div>
          <div className={styles.modal__timeStatus}>
            <div className={styles.timestatus__wrapper}>
              <div className={styles.timestatus__timeText}>Creation time</div>
              <div className={styles.timestatus__dateTime}>
                {user.isLoading ? (
                  <MySpinner />
                ) : (
                  getFormattedDate(presaleStore.buyInfo?.timestamp)
                )}
              </div>
            </div>
            <div className={styles.timestatus__line}></div>
            <div className={styles.timestatus__wrapper}>
              <div className={styles.timestatus__statusText}>
                Application status
              </div>
              <div className={styles.timestatus__dateTime}>
                {user.isLoading ? (
                  <MySpinner />
                ) : (
                  getFormattedDate(presaleStore.buyInfo?.timestamp)
                )}
              </div>
            </div>
          </div>
          {/* <div className={styles.modal__attention}>
        Attention! Click on the "Refresh page" button if you want to activate
        the automatic page update. The page will be updated every 30 seconds
      </div>
      <button className={styles.modal__buttonRefresh} onClick={handleReload}>
        Refresh page
      </button> */}
          <div className={styles.modal__bottomLine}></div>
        </div>
      </div>
    </>
  );
};

export default observer(PurchaseExcahnge);
